module.exports = __webpack_public_path__ + "img/app.store.7192ed4a.png";